import { IQuestionsGroupProps } from 'app/components/questions/base'
import { FandfPensionQuestionsGroup } from 'app/containers/PipelineSection/pension/Fandf'
import { PensionIntro } from 'app/containers/PipelineSection/Pension/Introduction'
import { IOPensionQuestionsGroup } from 'app/containers/PipelineSection/pension/IO'
import { IOLocal697PensionQuestionsGroup } from 'app/containers/PipelineSection/Pension/io/Local697'
import { Local697PensionQuestionsGroup } from 'app/containers/PipelineSection/pension/Local697'
import { Local697PlanPPensionQuestionsGroup } from 'app/containers/PipelineSection/pension/Local697PlanP'
import { Local145PensionQuestionsGroup } from 'app/containers/PipelineSection/pension/Local145'
import { Local701PensionQuestionsGroup } from 'app/containers/PipelineSection/pension/Local701'
import { Local705PensionQuestionsGroup } from 'app/containers/PipelineSection/pension/Local705'
import { LocalXXXPensionQuestionsGroup } from 'app/containers/PipelineSection/pension/LocalXXX'
import { Local74PensionQuestionsGroup } from 'app/containers/PipelineSection/pension/Local74'
import { Local401PensionQuestionsGroup } from 'app/containers/PipelineSection/pension/Local401'
import { CurrentPensionQuestionsGroup } from 'app/containers/PipelineSection/Pension/NCPERS/CurrentPension'
import { NEBFPensionQuestionsGroup } from 'app/containers/PipelineSection/Pension/NEBF'
import { NEBFLocal697PensionQuestionsGroup } from 'app/containers/PipelineSection/Pension/NEBF/Local697'
import { PriorPensionQuestionsGroup } from 'app/containers/PipelineSection/Pension/PriorPension'
import { SpousePensionQuestionsGroup } from 'app/containers/PipelineSection/Pension/Spouse Pension'
import { PensionSummary } from 'app/containers/PipelineSection/Pension/Summary'

interface IPensionQuestionGroups {
  PensionIntro: () => React.ReactElement<IQuestionsGroupProps>
  PensionSummary: () => React.ReactElement<IQuestionsGroupProps>
  CurrentPensionQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  SpousePensionQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  PriorPensionQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  FandfPensionQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  Local145PensionQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  Local705PensionQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  Local701PensionQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  Local697PensionQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  Local697PlanPPensionQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  LocalXXXPensionQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  Local74PensionQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  Local401PensionQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  IOPensionQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  IOLocal697PensionQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  NEBFPensionQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  NEBFLocal697PensionQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
}

const PensionQuestionGroups: IPensionQuestionGroups = {
  PensionIntro,
  PensionSummary,
  CurrentPensionQuestionsGroup,
  SpousePensionQuestionsGroup,
  PriorPensionQuestionsGroup,
  FandfPensionQuestionsGroup,
  Local145PensionQuestionsGroup,
  Local705PensionQuestionsGroup,
  Local701PensionQuestionsGroup,
  Local697PensionQuestionsGroup,
  Local697PlanPPensionQuestionsGroup,
  LocalXXXPensionQuestionsGroup,
  Local74PensionQuestionsGroup,
  Local401PensionQuestionsGroup,
  IOPensionQuestionsGroup,
  IOLocal697PensionQuestionsGroup,
  NEBFPensionQuestionsGroup,
  NEBFLocal697PensionQuestionsGroup
}

type PensionQuestionGroupsKeys = keyof IPensionQuestionGroups

export {
  IPensionQuestionGroups,
  PensionQuestionGroups,
  PensionQuestionGroupsKeys,
}



// WEBPACK FOOTER //
// ./src/app/containers/PipelineSection/Pension/index.ts